<template>
	<div class="cont_box">
		<div class="gall_box bai_box">
			<div class="gall_mbx">
				<el-breadcrumb separator=">">
					<el-breadcrumb-item>当前位置</el-breadcrumb-item>
					<!-- <el-breadcrumb-item>图库</el-breadcrumb-item> -->
					<el-breadcrumb-item>
						<span @click="sp_btn">{{codeName.name}}</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item>
						<span @click="k_btn">{{this.$route.query.zName}}</span>
					</el-breadcrumb-item>
					<el-breadcrumb-item v-if="this.$route.query.kName">
						{{this.$route.query.kName}}
					</el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="gall_slt" @click="sl_btn">
				<img src="../../assets/image/icon_tk_slt@2x.png" alt="" class="icon">
				<span>缩略图展示</span>
			</div>
			<div class="gall_cont">
				<div class="gall_item">
					<div class="gall_item_title">
						{{this.$route.query.mName}}  {{this.$route.query.kName}}
					</div>
					<div class="gall_item_p" >
						<div class="gall_item_a" @click="dec_btn(item)" v-for="(item,index) in gallData.records" :key="index">
							<div>
								{{item.name}} <span class="ld_font">{{item.latinName}}</span>
							</div>
<!--							{{item.celebrity}}, {{item.years}}-->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import headers from '@/components/header';
	import foot from '@/components/foot';
	export default {
		name: "UserDialong",
		data() {
			return {
				not_flag: true,
				tab_index: 'tk',
				currentPage3: 5,
				gallData: '', // 科目信息
				parat: {
					categoryId: this.$route.query.id,
					page: 1,
					size: 1000000,
				}
			}
		},
		mounted() {
			this.init()
		},
		computed:{
			codeName() {
				let name = ''
				for (let item of this.fldata) {
					if (item.code == this.gallyIndex) {
						name = item
					}
				}
				return name
			},
			gallyIndex() {
				return this.$store.state.gallyIndex
			},
			fldata() {
				return this.$store.state.fldata
			}
		},
		methods: {
			k_btn() {
				this.$router.go(-1)
			},
			sp_btn() {
				this.$router.push({
					path: 'galleryIndex'
				})
			},
			init() {
				this.$http.get('/front/gallery/galleries',this.parat).then(res => {
					this.gallData = res.data
					console.log(res)
				})
			},
			sl_btn() {
				this.$router.push({path: '/gallery_decTw',query: {mName: this.$route.query.mName,kName: this.$route.query.kName,zName: this.$route.query.zName,id: this.$route.query.id}})
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			dec_btn(item) {
				this.$router.push({path: '/gallery_describe',query: {id: item.id,cName: item.name,kName: this.$route.query.kName,zName: this.$route.query.zName,type: 'zc'}})
			}
		},
		components: {
			headers,
			foot,
		}
	}
</script>

<style lang="less" scoped>
	.gall_box{
		//width: 870px;
		width: 1200px;
		margin: 0 auto;
		.gall_mbx{
			margin: 0 0 30px;
			padding: 37px 23px 0;
			span{
				font-size: 13px;
				cursor: pointer;
			}
		}
		.gall_slt{
			display: flex;
			justify-content: flex-end;
			align-items: center;
			cursor: pointer;
			padding-right: 23px;
			.icon{
				width: 20px;
				height: 20px;
				margin-right: 15px;
			}
			span{
				font-size: 15px;
				color: #22AB67;
			}
		}
		.gall_fy{
			margin: 30px 0 60px;
			.block{
				display: flex;
				justify-content: center;
			}
		}
		.gall_cont{
			.gall_item{
				margin-top: 21px;
				.gall_item_title{
					height: 42px;
					background: #F5F5F5;
					padding-left: 23px;
					font-size: 18px;
					color: #333333;
					line-height: 42px;
					font-weight: bold;
				}
				.gall_item_p{
					padding: 16px 0;
					display: flex;
					flex-wrap: wrap;
					.gall_item_a{
						color: #4A4A4A;
						font-size: 13px;
						margin-bottom: 37px;
						width: 50%;
						box-sizing: border-box;
						padding-left: 59px;
						cursor: pointer;
						div{
							display: inline-block;
							padding-bottom: 1px;
							border-bottom: 1px solid #4A4A4A;
						}
					}
				}
			}
		}
	}
</style>
